import { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import MainPerfil from "./MainPerfil";
import MainDireccion from "./MainDireccion";
import MainSobreTi from "./MainSobreTi";
import MainRedes from "./MainRedes";
import {
  addProfileAddress, deleteProfileAddress, updateProfileAddress
} from "../../../actions/profile";
import { isEmpty } from "../../common/helpers";
import { Loading } from "../../common/Loading";
import StatusModal from "../../modals/StatusModal";
import ConfirmModal from "../../modals/ConfirmModal";

import { useSelector, useDispatch } from "react-redux";

const INITIAL_MODAL = { show: false, type: "SUCCESS" };

const MainInfo = () => {
  const dispatch = useDispatch();
  const profile = useSelector(state => state.profile.profile);
  const loading = useSelector(state => state.profile.loading);

  const infoDire = {
    direccion: "",
    calle: "",
    numeroExt: "",
    numeroInt: "",
    cp: "",
    colonia: "",
    municipio: "",
    nombre: "",
    estado: "",
    pais: "",
    referencia: "",
    place_id: "",
  };
  const redes = {
    instagram: "",
    facebook: "",
    linkedin: "",
    tiktok: "",
    youtube: "",
    twitter: ""
  };
  const [data, setData] = useState({
    ...infoDire,
    ...redes,
    rol: '',
    desc: '',
    website: ''
  });
  const [errors, setErrors] = useState({});
  const [idEliminar, setIdEliminar] = useState("");
  const [modalStatus, setModalStatus] = useState(INITIAL_MODAL);
  const [confirm, setConfirm] = useState(false);

  useEffect(() => {
    if (!isEmpty(profile?.redes) || !isEmpty(profile?.perfil)) {
      const {
        instagram, facebook, linkedin, tiktok, youtube, twitter
      } = profile?.redes || {};
      const { rol, desc, website } = profile?.perfil || {};
      setData({
        ...data,
        instagram: instagram || "",
        facebook: facebook || "",
        linkedin: linkedin || "",
        tiktok: tiktok || "",
        youtube: youtube || "",
        twitter: twitter || "",
        rol: rol || "",
        desc: desc || "",
        website: website || ""
      });
    }
  }, [profile]);

  const cambiarData = (key, value) => {
    setData({
      ...data,
      [key]: value,
    });
  }

  const guardar = async (id = null) => {
    // Validar que el cp tenga 5 digitos
    if (data.cp.length !== 5) {
      return setErrors(prev => ({
        ...prev,
        cp: "El código postal debe tener 5 dígitos",
      }));
    } else {
      setErrors(prev => ({
        ...prev,
        cp: "",
      }));
    }
    // Validar que los campos no esten vacios
    const keysToCheck = ["estado", "municipio", "colonia", "calle", "nombre", "pais"];
    keysToCheck.forEach(key => {
      if (isEmpty(data[key])) {
        return setErrors(prev => ({
          ...prev,
          [key]: "Este campo es requerido",
        }));
      } else {
        return setErrors(prev => ({
          ...prev,
          [key]: "",
        }));
      }
    });

    const info = {
      nombre: data.nombre,
      direccion: data.direccion,
      calle: data.calle,
      numeroInt: data.numeroInt,
      numeroExt: data.numeroExt,
      colonia: data.colonia,
      municipio: data.municipio,
      estado: data.estado,
      cp: data.cp,
      pais: data.pais,
      referencia: data.referencia,
      place_id: data.place_id,
    };
    if (id === null) {
      // Si no hay id, es porque es una nueva dirección
      const res = await dispatch(addProfileAddress(info));
      if (res) {
        return true;
      }
    } else {
      // Si hay id, es porque es una dirección existente
      const res = await dispatch(updateProfileAddress(info, id));
      if (res) {
        return true;
      }
    }
  }

  const eliminar = id => {
    setConfirm(true);
    setIdEliminar(id);
  }

  const handleDelete = async () => {
    setConfirm(false);

    try {
      await dispatch(deleteProfileAddress(idEliminar));
    } catch (error) {
      console.log('ERROR', error);
      setModalStatus({
        type: "ERROR",
        show: true,
      });
    } finally {
      setIdEliminar("");
    }
  }

  if (loading) {
    return <Loading />
  }

  return (
    <Grid container>
      <StatusModal
        closedModal={() => setModalStatus(INITIAL_MODAL)}
        show={modalStatus.show}
        type={modalStatus.type}
        message={modalStatus?.message ?? null}
      />
      <ConfirmModal
        show={confirm}
        message="¿Estás seguro de eliminar esta dirección?"
        cancel={() => {
          setConfirm(false);
          setIdEliminar("");
        }}
        confirm={handleDelete}
        btnTitle="Eliminar"
        color="error"
      />

      {/* Componente donde esta el email y el teléfono del usuario */}
      <MainPerfil />

      {/* Donde esta la dirección del usuario */}
      <MainDireccion
        direcciones={profile?.direcciones}
        infoDire={infoDire}
        data={data}
        errors={errors}
        setErrors={setErrors}
        setData={setData}
        cambiarData={cambiarData}
        guardar={guardar}
        eliminar={eliminar}
      />

      {/* Componente donde esta la descripción del usuario */}
      <MainSobreTi
        data={data}
        perfil={profile?.perfil}
        onChange={cambiarData}
      />

      {/* Componente donde estan las redes sociales del usuario */}
      <MainRedes
        data={data}
        redes={profile?.redes}
        cambiarData={cambiarData}
      />
    </Grid>
  )
}

export default MainInfo;
